import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateAppointmentExchangeRequest, appointmentExchangesApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

/** Publishes a new Tauschanfrage; refreshes the lists, the sidebar badge and the exchangeable Termine. */
export function useCreateExchangeMutation() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showSuccess } = useAlertContext();

  return useMutation({
    mutationFn: (request: CreateAppointmentExchangeRequest) =>
      appointmentExchangesApi.createAppointmentExchange({ createAppointmentExchangeRequest: request }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.AppointmentExchanges] });
      showSuccess(t("exchange.newRequestDialog.successMessage"));
    },
  });
}
